import React from "react";
import { Fade } from "react-awesome-reveal";
import { socialLinks } from "../../config/Social";
import { ReactComponent as GithubIcon } from "../../assets/icons/github.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/icons/linkedin.svg";
import { ReactComponent as XIcon } from "../../assets/icons/x.svg";
import { ReactComponent as UpworkIcon } from "../../assets/icons/upwork.svg";
import { ReactComponent as YoutubeIcon } from "../../assets/icons/youtube.svg";
import "./Footer.css";

const icons = {
    github: GithubIcon,
    linkedin: LinkedinIcon,
    twitter: XIcon,
    upwork: UpworkIcon,
    youtube: YoutubeIcon,
};

const Footer = () => {
    return (
        <footer>
            <Fade>
                <div className="footer-links">
                    {Object.entries(socialLinks).map(([key, social]) => {
                        const IconComponent = icons[key];
                        return (
                            social.url && IconComponent && (
                                <a key={key} href={social.url} target="_blank" rel="noopener noreferrer" aria-label={social.label}>
                                    <IconComponent />
                                </a>
                            )
                        );
                    })}
                </div>
                <div className="footer-text">
                    <a
                        className="hover-underline-animation"
                        href="https://github.com/bchiang7/v4"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Designed by Brittany Chiang & Built by Jay Patel
                    </a>
                </div>
            </Fade>
        </footer>
    );
};

export default Footer;
